import { apiGet, apiPost } from '@/utils/request'
import { EP } from './endpoints'

export interface CurrentUser {
  id: string
  username: string
  display_name?: string
  force_password_change: boolean
  roles: string[]
  permissions: string[]
}

export const login = (data: { username: string; password: string }) =>
  apiPost<CurrentUser>(EP.auth.login, data)

export const logout = () =>
  apiPost<void>(EP.auth.logout)

export const getCurrentUser = () =>
  apiGet<CurrentUser>(EP.auth.me, { timeout: 10_000 })

export const changePassword = (data: { old_password: string; new_password: string }) =>
  apiPost<void>(EP.auth.changePassword, data)
